module.exports = __webpack_public_path__ + "static/media/success.7ab4646c.svg";